import React, { Fragment } from 'react';
import styles from './CardWithCheck.module.css';

const CardWithCheck = ({
  checked,
  img,
  label,
  onSetValue,
  iconprops = true,
  containerStyle = 'xl:w-40 lg:w-56 w-44 h-16 cursor-pointer py-2 my-1 px-1',
  topRightCheck = false,
  rightCheck = true,
  component,
  cardContainerStyle = {}
}) => {
  const {
    block_box_all,
    outer_box_unassigned,
    assignedImg,
    assignImg,
    outer_box_assigned,
    block_img_block,
    checkboxDiv,
    assignedImgTop
  } = styles;
  return (
    <Fragment>
      <div
        className={`${containerStyle} flex relative ${
          iconprops ? block_box_all : block_img_block
        } 
         ${
           checked
             ? `bg-green-100 ${outer_box_assigned}`
             : `bg-white  ${outer_box_unassigned}`
         }`}
        onClick={onSetValue}
        style={cardContainerStyle}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '20% 75%',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {component ? component : null}
          {!component && iconprops && img && (
            <div className="h-6 w-6">
              <img className="cursor-pointer w-full h-full" src={img} />
            </div>
          )}

          <div className=" ">
            <p
              className={`${
                iconprops
                  ? 'font-roboto font-normal text-xs py-1 text-black-850'
                  : 'font-roboto font-normal text-xs py-1 text-black-850 pl-1 text-left'
              }`}
            >
              {label}
            </p>
          </div>
        </div>
        {rightCheck && !topRightCheck && (
          <div
            className={`${
              checked ? `${assignedImg} ml-auto` : `${assignImg} ml-auto`
            }`}
          ></div>
        )}
        {topRightCheck && !rightCheck && (
          <div
            className={`${
              checked ? `${checkboxDiv} right-0 top-0 absolute` : `hidden`
            }`}
          >
            <div
              className={`${
                checked ? `${assignedImgTop}` : `${assignImg} ml-auto`
              }`}
            ></div>
          </div>
        )}
      </div>
    </Fragment>
  );
};
export default CardWithCheck;
